import React from 'react'
import PropTypes from 'prop-types'

// Based on https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
export default class OutsideClicker extends React.Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);           
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if(this.props.onClick && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.onClick(event)
    }
  }

  render() {
    return (
      <div ref={this.setWrapperRef}>
        {this.props.children}
      </div>
    );
  }
}

OutsideClicker.propTypes = {
  children: PropTypes.element.isRequired,
  onClick: PropTypes.func
}
